import React from "react";
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Icon,
  Button,
  Link,
} from "@chakra-ui/react";
import { MdPending, MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ChatState } from "../Context/ChatProvider";
import { SUPPORT_EMAIL } from "../config/constants";

const VendorPendingApproval = () => {
  const navigate = useNavigate();
  const { setUser } = ChatState();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userInfo");
    setUser(null);
    navigate("/login");
  };

  return (
    <Container maxW="xl" centerContent>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        width="100%"
      >
        <VStack
          spacing={6}
          bg="white"
          p={8}
          borderRadius="lg"
          borderWidth="1px"
          boxShadow="lg"
          textAlign="center"
        >
          <Icon as={MdPending} w={20} h={20} color="orange.400" />

          <Heading size="xl" color="gray.700">
            Account Pending Approval
          </Heading>

          <Text fontSize="lg" color="gray.600" maxW="md">
            Thank you for registering as a vendor! Your account is currently
            under review by our team.
          </Text>

          <Box
            bg="orange.50"
            p={4}
            borderRadius="md"
            borderWidth="1px"
            borderColor="orange.200"
            width="100%"
          >
            <VStack spacing={3}>
              <Icon as={MdEmail} w={8} h={8} color="orange.500" />
              <Text fontSize="md" fontWeight="semibold" color="gray.700">
                Need assistance?
              </Text>
              <Text fontSize="sm" color="gray.600">
                Please contact us at:
              </Text>
              <Link
                href={`mailto:${SUPPORT_EMAIL}`}
                fontSize="lg"
                color="blue.500"
                fontWeight="bold"
                _hover={{ textDecoration: "underline" }}
              >
                {SUPPORT_EMAIL}
              </Link>
            </VStack>
          </Box>

          <Text fontSize="sm" color="gray.500" maxW="md">
            You will receive an email notification once your account has been
            approved. This process typically takes 1-2 business days.
          </Text>

          <Button
            colorScheme="gray"
            variant="outline"
            onClick={handleLogout}
            mt={4}
          >
            Logout
          </Button>
        </VStack>
      </Box>
    </Container>
  );
};

export default VendorPendingApproval;
